// storeデータ用意
// 事前にキーを入力しなくても保存が可能だが、混乱を避けるために事前に入力したいためDB設計を確認し、必要な情報を記述している
export const STORE = {
  /** トークン */
  mtmrToken: "",

  // mtgCallbackページの入力値
  mtgCallback: {
    // mtgから取得した顧客データ格納先
    memberInfoList: "",
    // 選択された契約データvalue格納先
    selectedKykVal: "",
    // 選択された契約データ箇所
    mtgLoginSelect: "",
  },

  /** ご希望日時 入力値 */
  storeAppointment: {
    // 郵便番号
    yubinNo: null,
    // 都道府県・市区町村・丁目（コード）
    addressKj: null,
    // 都道府県・市区町村・丁目（漢字）
    addressKjLabel: null,
    // ご希望日時（年月日）
    appointmentYmd: null,
    // ご希望訪問時間コード
    appointmentHmTimeCd: null,
    // ご希望日時選択ページ
    selectedPage: 0,
    // 担当法人コード
    tntHjnCd: null,
    // 担当店舗コード
    tntShopCd: null,
    // 担当店舗名称
    tntShopName: null,
    // 担当店舗電話番号
    tntTelNo: null,
  },

  /** 機器選択入力値 */
  storeKikiSelect: {
    // 選択機器値
    selectKiki: [],
    // 選択機器名称
    selectKikiNm: [],
    // ご要望
    request: null,
    // 添付写真①
    tmpImage1: null,
    // 添付写真①拡張子
    tmpImageMine1: null,
    // 添付写真②
    tmpImage2: null,
    // 添付写真②拡張子
    tmpImageMine2: null,
    // 添付写真③
    tmpImage3: null,
    // 添付写真③拡張子
    tmpImageMine3: null,
  },

  /** お客さま情報入力 入力値 */
  storeContract: {
    // お客さま番号
    custNo: null,
    // お客さま登録番号
    custRegistNo: null,
    // 所有機器番号
    shoyKkNo: null,
    // メールアドレス
    mailaddress: null,
    // メールアドレス（確認）
    mailaddressAgain: null,
    // 申し込み 姓
    mskmSei: null,
    // 申し込み 名
    mskmMei: null,
    // 申し込み セイ
    mskmSeiKn: null,
    // 申し込み メイ
    mskmMeiKn: null,
    // 携帯電話番号
    phoneNo: null,
    // 固定電話番号
    telNo: null,
    // 番地
    bant: null,
    // 号
    go: null,
    // 建物名
    bldNmKj: null,
    // 棟番
    muneban: null,
    // 部屋番
    heyaban: null,
    // ご連絡事項など
    contact: null,
    // メールでのご案内について
    guidanceAgree: false,
    // myTOKYOGASから自動入力ボタン表示制御
    isDispMtgBtn: null,
    // myTOKYOGASラジオボタン表示制御
    isDispMtgSlct: null,
    // myYOKYOGASラジオボタン選択値
    mtgLoginSelect: null,
  },

  /** 確認画面 */
  storeConfirm: {
    // 受付番号
    uktkNo: null,
  },
};